import React from 'react';
import './ConferenceCard.css';

const ConferenceCard = ({ conference, isAttending = false, onToggleAttendance }) => {
  const formatDateDay = dateStr => {
    if (!dateStr) return '';
    const parsed = new Date(dateStr);
    if (!Number.isNaN(parsed.getTime())) {
      const day = parsed.getUTCDate().toString().padStart(2, '0');
      return day;
    }
    return '';
  };

  const formatDateMonth = dateStr => {
    if (!dateStr) return '';
    const parsed = new Date(dateStr);
    if (!Number.isNaN(parsed.getTime())) {
      const monthIndex = parsed.getUTCMonth();
      const monthNames = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
      return monthNames[monthIndex];
    }
    return '';
  };

  const handleLinkClick = event => {
    event.stopPropagation();
    if (conference.Link) {
      window.open(conference.Link, '_blank', 'noopener,noreferrer');
    }
  };

  const handleAttendanceToggle = event => {
    event.stopPropagation();
    event.preventDefault();
    if (typeof onToggleAttendance === 'function') {
      onToggleAttendance(conference, !isAttending);
    }
  };

  return (
    <div className="conference-card">
      <div className="conference-card__content">
        {/* Header avec logo, nom organisation et actions */}
        <div className="conference-card__header">
          <div className="conference-card__header-left">
            {conference.Organization_picture && (
              <div className="conference-card__org-logo">
                <img
                  src={conference.Organization_picture}
                  alt="Organization"
                  loading="lazy"
                />
              </div>
            )}
            {conference.Organization_name && (
              <div className="conference-card__org-name">
                {conference.Organization_name}
              </div>
            )}
          </div>

          <div className="conference-card__header-actions">
            <button
              type="button"
              className={`conference-card__icon-btn conference-card__favorite-btn${isAttending ? ' active' : ''}`}
              onClick={handleAttendanceToggle}
              aria-pressed={isAttending}
              aria-label={isAttending ? 'Remove from favorites' : 'Add to favorites'}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill={isAttending ? "currentColor" : "none"} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
              </svg>
            </button>

            {conference.Link && (
              <button
                type="button"
                className="conference-card__icon-btn conference-card__link-btn"
                onClick={handleLinkClick}
                aria-label="Open conference link"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                  <polyline points="15 3 21 3 21 9" />
                  <line x1="10" y1="14" x2="21" y2="3" />
                </svg>
              </button>
            )}
          </div>
        </div>

        {/* Image principale */}
        {conference.picture && (
          <div className="conference-card__image">
            <img
              src={conference.picture}
              alt={conference.name}
              loading="lazy"
            />
          </div>
        )}

        {/* Titre */}
        <div className="conference-card__title">
          {conference.name || 'Conference sans nom'}
        </div>

        {/* Date et lieu */}
        <div className="conference-card__info">
          {conference.date_debut2 && (
            <div className="conference-card__date">
              <div className="conference-card__date-calendar">
                <div className="conference-card__date-days">
                  {formatDateDay(conference.date_debut2)}
                  {conference.date_fin3 && formatDateDay(conference.date_fin3) !== formatDateDay(conference.date_debut2) && (
                    <> - {formatDateDay(conference.date_fin3)}</>
                  )}
                </div>
                <div className="conference-card__date-month">{formatDateMonth(conference.date_debut2)}</div>
              </div>
            </div>
          )}

          {conference.Country && (
            <div className="conference-card__location">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              <span>{conference.City ? `${conference.City}, ` : ''}{conference.Country}</span>
            </div>
          )}
        </div>

        {/* Badges */}
        <div className="conference-card__badges">
          {conference.presence && (
            <span className="conference-card__badge conference-card__badge--format">
              {conference.presence}
            </span>
          )}
          {conference.Price && (
            <span className="conference-card__badge conference-card__badge--price">
              {conference.Price}
            </span>
          )}
          {conference.type && (
            <span className="conference-card__badge conference-card__badge--type">
              {conference.type}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConferenceCard;